import { combineReducers } from 'redux';

import { generateYesterdayDate } from '../Common/utils';

import {
  SET_BUSINESS_FILTERS,
  RESET_BUSINESS_FILTERS,
  SET_BUSINESS_GRID_SORT_CRITERIA,
} from './actionTypes';

const yesterdayDate = generateYesterdayDate();

const businessFiltersInitialState = {
  startDate: yesterdayDate,
  endDate: yesterdayDate,
  partnerID: 'ALL',
  aggregatorID: 'ALL',
  visitStatus: 'ALL',
};

const businessGridSortCriteriaInitialState = {
  sortByColumn: 'aggregatorID',
  sortDirection: 'up',
};

const businessFiltersReducer = (
  state = businessFiltersInitialState,
  { type = '', filters = { ...businessFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_BUSINESS_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_BUSINESS_FILTERS:
      return {
        ...state,
        ...businessFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentBusinessGridSortCriteriaReducer = (
  state = businessGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...businessGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_BUSINESS_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const businessReducer = combineReducers({
  businessFilters: businessFiltersReducer,
  businessGridSortCriteria: currentBusinessGridSortCriteriaReducer,
});

export { businessReducer, businessFiltersInitialState, businessGridSortCriteriaInitialState };
